import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, catchError, of, switchMap } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth     = inject(AuthService);
  const keycloak = inject(KeycloakService);

  if (!req.url.startsWith('/api/')) {
    return next(req);
  }

  // Silently refresh if the token expires within 30 s.
  // catchError lets the request proceed with the current token if
  // the refresh call itself fails (offline, session already ended).
  return from(keycloak.updateToken(30)).pipe(
    catchError(() => of(false)),
    switchMap(() => attachAndForward(req, next, auth)),
  );
};

// Exported so errorInterceptor can retry a request with a freshly-refreshed token.
export function attachAndForward(
  req: Parameters<HttpInterceptorFn>[0],
  next: Parameters<HttpInterceptorFn>[1],
  auth: AuthService,
) {
  const token = auth.getToken();
  // In coda alle preferenze salvate c'è la lingua del bundle in esecuzione, non
  // l'italiano: se l'interfaccia è in tedesco, l'agente deve rispondere in
  // tedesco anche per un utente senza preferenza. La build localizzata scrive
  // la locale in `<html lang>`; qui si legge da lì e non da `inject(LOCALE_ID)`
  // perché questa funzione viene richiamata anche da `errorInterceptor`, dentro
  // un operatore rxjs, dove il contesto di iniezione non c'è più.
  const lang  = auth.currentUser()?.preferred_language
             ?? localStorage.getItem('lang')
             ?? document.documentElement.lang
             ?? 'it';
  if (!token) return next(req);
  return next(req.clone({
    headers: req.headers
      .set('Authorization', `Bearer ${token}`)
      .set('Accept-Language', lang),
  }));
}
